import {
  Component,
  ElementRef,
  OnInit,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'frontend-redirect-to-app',
  templateUrl: './redirect-to-app.component.html',
  styleUrls: ['./redirect-to-app.component.scss'],
})
export class RedirectToAppComponent implements OnInit {
  // @Input() tokenDetail: any;
  public closeEvent: EventEmitter<any> = new EventEmitter();
  // totalToken: number = 0;

  @ViewChild('videoPlayer') videoPlayer: ElementRef<HTMLVideoElement>;
  videourl: string;
  isPlaying = false;

  constructor(public modalRef: BsModalRef<RedirectToAppComponent>) {}

  ngOnInit(): void {
    // console.log('======================', this?.tokenDetail);
    // this.totalToken = Number(this.tokenDetail?.billing_details?.user_id?.tokens) + Number(this.tokenDetail.tokens)
  }


  confirm() {
    this.closeEvent.emit({close: true});
    this.modalRef?.hide()
  }
}
